import { render, staticRenderFns } from "./LibraryDetails.vue?vue&type=template&id=e8edce36"
import script from "./LibraryDetails.vue?vue&type=script&lang=js"
export * from "./LibraryDetails.vue?vue&type=script&lang=js"
import style0 from "./LibraryDetails.vue?vue&type=style&index=0&id=e8edce36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports